export default __webpack_public_path__ + "static/media/229.3c5afacb.jpg";